import { render, staticRenderFns } from "./rateTable.vue?vue&type=template&id=d5af0726&scoped=true"
import script from "./rateTable.vue?vue&type=script&lang=js"
export * from "./rateTable.vue?vue&type=script&lang=js"
import style0 from "./rateTable.vue?vue&type=style&index=0&id=d5af0726&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5af0726",
  null
  
)

export default component.exports